import { Directive, ElementRef, forwardRef, Renderer2, HostListener } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';

const TRIM_VALUE_ACCESSOR = {
  provide: NG_VALUE_ACCESSOR,
    // eslint-disable-next-line
  useExisting: forwardRef(() => FromControlTrimDirective),
  multi: true
};

@Directive({
  selector: 'input[trim]',
  providers: [TRIM_VALUE_ACCESSOR]
})
export class FromControlTrimDirective implements ControlValueAccessor {
  private onTouchedCallback: any;
  private onChangeCallback: any;

  constructor (
    private _elementRef: ElementRef
  ) {}

  writeValue(value: any): void {
    this._elementRef.nativeElement.value = value;
  }

  registerOnChange(fn: any): void {
    this.onChangeCallback = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouchedCallback = fn;
  }

  @HostListener('blur', ['$event.target'])
  onBlur(element: HTMLInputElement) {
    const val = element.value.trim();
    this.writeValue(val);
    this.onChangeCallback(val);
  }

  @HostListener('keyup', ['$event.target'])
  onKeyup(element: HTMLInputElement) {
    this.onChangeCallback(element.value);
  }
}
